import { GatsbyImage } from 'gatsby-plugin-image';
import styled, { keyframes } from 'styled-components';

import { Link } from '@powdr/components';
import { ThemeProps as Prop, Components } from '@powdr/constants';
import { themeUtil } from '@powdr/utils';

const CPNT = Components.IMAGE_MARQUEE;

const createScrollAnimation = (repeatCount) => keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-${100 / repeatCount}%);
  }
`;

export const StyledImageMarquee = styled.div`
  width: 100%;
  overflow: hidden;
  padding: 10px 0;
`;

export const MarqueeTrack = styled.div`
  display: flex;
  width: max-content;
  animation: ${({ $repeatCount }) => createScrollAnimation($repeatCount)} 30s linear infinite;
  will-change: transform;

  &:hover {
    animation-play-state: paused;
  }
`;

export const MarqueeSet = styled.div`
  display: flex;
`;

export const MarqueeItemWrapper = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MarqueeImage = styled(GatsbyImage)`
  width: 150px;
  object-fit: contain;
`;

export const MarqueeItem = styled.div`
  flex: 0 0 auto;
  margin: 0 25px;

  .marquee-icon {
    svg {
      fill: ${({ $colorProfile }) => themeUtil(Prop.ICON, CPNT, $colorProfile)};
      color: ${({ $colorProfile }) => themeUtil(Prop.ICON, CPNT, $colorProfile)};
    }
  }
`;
